export default __webpack_public_path__ + "static/shaneSpilling-f1effcc2e2fb72a36028e2afe9bf00eb.svg";